import { useQuery } from 'react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { getAccountV2Summary } from 'services/accountV2/accountV2Service';
import { GlobalStoreInterface } from 'interface/globalStore';
import { ACCOUNT_V2_SUMMARY_QUERY_KEY } from '../../constants/purchaseLicenseModalConstants';

export const useGetAccountV2Summary = (setGlobalAccountV2Summary) => {
  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );

  const corpAccountNumber: string =
    globalStoreData?.user?.accountInfo?.corpAcctNbr ??
    globalStoreData?.user?.profileDTO?.corpAcctNbr;

  return useQuery(
    [ACCOUNT_V2_SUMMARY_QUERY_KEY],
    () => getAccountV2Summary(corpAccountNumber),
    {
      enabled: Boolean(corpAccountNumber),
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess: (response) => {
        setGlobalAccountV2Summary(response);
      },
    },
  );
};
